import React, { Component } from 'react';

import { NewsItem } from '@interfaces/news-page';
import News from '@components/news-widget';
import PageMeta from '@components/page-meta';
import { ShowMore, PaginationWrapperProps } from '@components/pagination-wrapper';

import NewsListStub from './news-list.stub';
import pageConfig from './page-config.json';

export interface DispatchProps {
    fetchPage(pageNumber?: number): void;
}

export interface SizeProps {
    isDesktop: boolean;
}

export interface StateProps {
    rows: NewsItem[];
}

type Props = SizeProps & StateProps & DispatchProps & PaginationWrapperProps;

export default class NewsList extends Component<Props> {
    public render() {
        const { isLoading, displayShowMore, rows, isDesktop, onClick } = this.props;
        const showMoreProps = { displayShowMore, isLoading, onClick };

        // Когда грузим список новостей первый раз
        if (isLoading && !rows.length) {
             return <NewsListStub compact={!isDesktop} />;
        }

        return (
            <div className="block centering">
                <PageMeta title={pageConfig.meta.title} description={pageConfig.meta.description} />
                <h1 className="block__title">News</h1>
                <News
                    compact={!isDesktop}
                    type="vertical"
                    items={rows}
                />
                <ShowMore {...showMoreProps} />
            </div>
        );
    }
}
